// Module
var code = "<react-component name=\"TrainerPayrollReport\"></react-component>\n";
// Exports
module.exports = code;